<template>
    <div id="address-confirmation">
        <div class="address-header flex justify-between">
            <h5 class="address-title lowercase capitalize"> {{ title }}</h5>
            <div class="flex pt-2.5">
                <button class="flex gap-1/4 justify-between w-30" v-if="isPhoenixCustomer && this.$route.name === 'Review'" @click="$emit('editBilling')">
                    <img :src="checkoutSharedContent.renewalEditIcon.fields.file.url" >
                    <div class="edit-fields">{{ editInfoText }}</div>
                </button>
            </div>
        </div>
        <div class="address-details">
            <div>{{ address.firstName }} {{address.lastName}}</div>
            <div>{{ address.email }}</div>
            <div>{{ address.phone }}</div>
            <div>{{ address.address1 }} {{ address.address2 }}</div>
            <div>
                <span>{{ address.city }},</span>
                <span v-if="shouldShowState">{{ address.state }}</span>
                <span>{{ address.zip }},</span>
                <span>{{ address.country}}</span>
            </div>
            <div v-if="address.vatId">{{ address.vatId }}</div>
        </div>
    </div>
</template>


<script>
import {mapGetters} from 'vuex'
    export default {
        props: {
            address: {
                type: Object,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            editInfoText: {
                type: String,
                required: false,
                default: "Edit Info"
            }
        },
        data() {
            return {}
        },
        computed: {
            ...mapGetters(['isPhoenixCustomer']),
            ...mapGetters('content', [
                'checkoutSharedContent'
            ]),
            shouldShowState() {
                return ['United States', 'Canada', 'Ireland'].includes(this.address.country);
            }
        },

    }
</script>

<style scoped>
    .address-details {
        font-size: 18px;
        line-height: 120%;
    }

    .edit-fields{
        font-size: 18px;
        line-height: 22px;
        font-weight: 500;
        color: #0C6EDE
    }

    @media (min-width: 736px) {
        #address-confirmation {
            max-width: 100% !important;
            width: 100%;
            flex-basis: 100%;
        }
    }


    .address-title {
        font-weight: 500;
        font-size: 24px;
        border-left: 0px solid;
        border-right: 0px solid;
        border-top: 0px solid;
        padding-top: 10px;
        line-height:0px;
    }

    .col {
        margin-left: -1px; /* Safari display fix */
    }

    .no-side-padding {
        padding-left: 0px;
        padding-right: 0px;
    }

    .address-header{
        border-bottom: 2px solid #f0f0f0;
        margin-bottom: 20px;
    }

</style>
